module.exports = {"apiKey":"AIzaSyA8els0yPulfAlLHnwqD9MQ0_afUJWg9Q8","authDomain":"auth.maprinter.com","databaseURL":"maprinter-f4b78.firebaseio.com","projectId":"maprinter-f4b78","storageBucket":"maprinter-f4b78.appspot.com","messagingSenderId":"137262836911"}


//////////////////
// WEBPACK FOOTER
// ./src/json/firebase.json
// module id = oyK2
// module chunks = 1